import styled, { css } from "styled-components";
import { colors } from "./variables.js";

export const Highlight = styled.span`
	color: ${colors.accent};
`;
